// extracted by mini-css-extract-plugin
module.exports = {"container":"typeForm_container__dh__C"};